import script from "./MainTop.vue?vue&type=script&setup=true&lang=js"
export * from "./MainTop.vue?vue&type=script&setup=true&lang=js"

import "./MainTop.vue?vue&type=style&index=0&id=84a5c8a6&lang=less&scoped=true"

import exportComponent from "D:\\yisa_project\\访客预约系统\\vrs_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84a5c8a6"]])

export default __exports__